import api from '../axiosConfig';
import { MEDIA } from '../config/apiEndpoints';

export const MediaService = {
    /**
     * Upload a raw file binary payload to S3.
     * `x-tenant-id` is automatically attached via axios interceptor.
     * 
     * @param {File} file - Raw File or Blob object.
     * @param {Function} onProgress - Progress callback function receiving percentage.
     * @returns {Promise<Object>} - Contains public URL of the uploaded asset.
     */
    uploadFile: async (file, onProgress) => {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await api.post(MEDIA.UPLOAD, formData, {
                onUploadProgress: (progressEvent) => {
                    if (onProgress && progressEvent.total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        onProgress(percentCompleted);
                    }
                }
            });
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('MediaService uploadFile error:', error);
            throw error;
        }
    }
};
